import { render, staticRenderFns } from "./CustomerListFilter.vue?vue&type=template&id=0a395f53&scoped=true"
import script from "./CustomerListFilter.vue?vue&type=script&lang=js"
export * from "./CustomerListFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomerListFilter.vue?vue&type=style&index=0&id=0a395f53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a395f53",
  null
  
)

export default component.exports